import { FilterDefinition, ListViewFilters, ListViewSort } from '../types';

type AllParams = {
  pageIndex: number;
  pageSize: number;
  sort: ListViewSort | null;
} & ListViewFilters;

/**
 * Returns true when pagination/sort/filters match ListView defaults (nothing user-specific in URL state).
 * Used to avoid overwriting sticky storage when chip navigation resets params to defaults.
 */
export function areListViewParamsAtDefaults(
  allParams: AllParams,
  filters: FilterDefinition[] | undefined,
  defaultPageSize: number,
): boolean {
  if (allParams.pageIndex !== 0) {
    return false;
  }
  if (allParams.pageSize !== defaultPageSize) {
    return false;
  }
  if (allParams.sort != null) {
    return false;
  }

  for (const filter of filters ?? []) {
    const value = allParams[filter.name];
    const parser = filter.parser as {
      defaultValue?: unknown;
      eq?: (a: unknown, b: unknown) => boolean;
    };
    const defaultValue = parser.defaultValue;

    if (defaultValue === undefined) {
      if (value != null && value !== '') {
        return false;
      }
      continue;
    }

    if (parser.eq) {
      if (!parser.eq(value, defaultValue)) {
        return false;
      }
      continue;
    }

    if (value !== defaultValue) {
      // Object defaults (e.g. date range) without eq: compare JSON
      if (typeof value === 'object' && value != null) {
        if (JSON.stringify(value) !== JSON.stringify(defaultValue)) {
          return false;
        }
      } else {
        return false;
      }
    }
  }

  return true;
}
